import script from "./Integrations.vue?vue&type=script&setup=true&lang=js"
export * from "./Integrations.vue?vue&type=script&setup=true&lang=js"

import "./Integrations.vue?vue&type=style&index=0&id=82dfd6dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82dfd6dc"]])

export default __exports__